import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=fd31122c&scoped=true"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"
import style0 from "./banners.vue?vue&type=style&index=0&id=fd31122c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31122c",
  null
  
)

export default component.exports